import { Entity, IEntity } from "./Entity";

export interface IRiskAppIncidentImpactType extends IEntity {
    ImpactTypeID?: number;
    IncidentID?: number;
}

export class RiskAppIncidentImpactType extends Entity implements IRiskAppIncidentImpactType {
    public ImpactTypeID = null;
    public IncidentID = null;
}